import React from "react";
import { PhotoCameraOutlined } from "@material-ui/icons";
import { Button, withStyles } from "@material-ui/core";

const styles = () => ({
  text: {
    fontSize: 12,
    textDecoration: "underline",
    paddingLeft: 4,
  },
});

const ViewStopImages = (props) => {
  return (
      <Button color="primary" variant="text" onClick={props.onClick}>
        <PhotoCameraOutlined />
        <span className={props.classes.text}>
          View stop images
        </span>
      </Button>
  );
};

export default withStyles(styles)(ViewStopImages);
